import React from "react"
import PropTypes from "prop-types"

import css from "./Separator.scss"

const SEPARATOR_SIZES = {
    xs: "extraSmall",
    sm: "small",
    md: "medium",
    lg: "large",
}

const Separator = React.memo(function Separator({ size, type, label, marginTop, marginBottom, className }) {
    if (label) {
        return (
            <div className={`flex alignCenter ${className}`} style={{ marginTop, marginBottom }}>
                <div className={`${css.separator} ${css[SEPARATOR_SIZES[size]]} ${css.flexGrow}`} />
                <div className="padding-0-8 textTertiary">{label}</div>
                <div className={`${css.separator} ${css[SEPARATOR_SIZES[size]]} ${css.flexGrow}`} />
            </div>
        )
    }
    return type === "dashed" ? (
        <div
            className={`${css[SEPARATOR_SIZES[size]]} ${css.dashedLine} ${className}`}
            style={{ marginTop, marginBottom }}
        />
    ) : (
        <div
            className={`${css.separator} ${css[SEPARATOR_SIZES[size]]} ${className}`}
            style={{ marginTop, marginBottom }}
        />
    )
})

Separator.propTypes = {
    type: PropTypes.oneOf(["dashed", "solid"]),
    size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
    label: PropTypes.string,
    marginTop: PropTypes.number,
    marginBottom: PropTypes.number,
    className: PropTypes.string,
}

Separator.defaultProps = {
    size: "sm",
    className: "",
}

export default Separator
